/* tslint:disable */
import {
  Paastenant,
  Tenant
} from '../index';

declare var Object: any;
export interface AccountInterface {
  accounttype: string;
  realm?: string;
  username?: string;
  password: string;
  email: string;
  emailVerified?: boolean;
  verificationToken?: string;
  id?: any;
  createdAt: Date;
  updatedAt: Date;
  paastenantId?: any;
  tenantId?: any;
  accessTokens?: any[];
  paastenant?: Paastenant;
  tenant?: Tenant;
}

export class Account implements AccountInterface {
  accounttype: string;
  realm: string;
  username: string;
  password: string;
  confirmpassword: string;
  email: string;
  emailVerified: boolean;
  verificationToken: string;
  id: any;
  createdAt: Date;
  updatedAt: Date;
  paastenantId: any;
  tenantId: any;
  accessTokens: any[];
  paastenant: Paastenant;
  tenant: Tenant;
  entities: any[];
  linked_outlets: any[];
  constructor(data?: AccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Account`.
   */
  public static getModelName() {
    return "Account";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Account for dynamic purposes.
  **/
  public static factory(data: AccountInterface): Account{
    return new Account(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Account',
      plural: 'accounts',
      properties: {
        accounttype: {
          name: 'accounttype',
          type: 'string',
          default: 'platform'
        },
        realm: {
          name: 'realm',
          type: 'string'
        },
        username: {
          name: 'username',
          type: 'string'
        },
        password: {
          name: 'password',
          type: 'string'
        },
        confirmpassword: {
          name: 'confirmpassword',
          type: 'string'
        },
        email: {
          name: 'email',
          type: 'string'
        },
        emailVerified: {
          name: 'emailVerified',
          type: 'boolean'
        },
        verificationToken: {
          name: 'verificationToken',
          type: 'string'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
        paastenantId: {
          name: 'paastenantId',
          type: 'any'
        },
        tenantId: {
          name: 'tenantId',
          type: 'any'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: ''
        },
        paastenant: {
          name: 'paastenant',
          type: 'Paastenant',
          model: 'Paastenant'
        },
        tenant: {
          name: 'tenant',
          type: 'Tenant',
          model: 'Tenant'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Account.ts